import ddt from '@wix/da-ddt';
import { FlagPredicate, FlagsObject } from './types';

const logger = ddt.createLogger('flags');

export function isFlagEnabled(
  flags: FlagsObject,
  condition: string | FlagPredicate
) {
  if (!flags) {
    logger.error('No flags object passed');
    return false;
  }

  if (typeof condition === 'string') {
    return !!flags[condition];
  }

  return condition(flags);
}

export function isAnyFlagEnabled(flags: FlagsObject, conditions: string[]) {
  if (!flags) {
    logger.error('No flags object passed');
    return false;
  }

  return conditions.some(flag => !!flags[flag]);
}

export function getEnabledFlagList(flags: FlagsObject) {
  if (!flags) {
    logger.error('No flags object passed');
    return [];
  }
  return Object.keys(flags).filter(flag => !!flags[flag]);
}

/**
 * Converts the features array into features object
 */
export function flagsFromSession(
  features?: string[] | undefined | null
): FlagsObject {
  if (!features) {
    return {};
  }
  return features.reduce((o, feature) => ({ ...o, [feature]: true }), {});
}

export function addCalculatedFlags(source: FlagsObject): FlagsObject {
  if (!source) {
    logger.error('No flags object passed');
    return {};
  }

  return {
    // any explicitly set flags override the calculated ones
    ...source,
  };
}
